import {NgModule} from '@angular/core';
import {CoreModule} from '../../core/core.module';
import {VS_ENTITY_PROVIDER} from './vs.entity-provider';
import {DynamicModule} from '../../core/shared/interface/dynamic-module.interface';
import {ModuleRegistryService} from '../../core/shared/interface/module-registration.service';
import {VsConfigPage} from './page/overview/vs-config/vs-config.page';
import {VsVisitPage} from './page/object/vs-visit-page/vs-visit.page';
import {VsVisitComponent} from './component/object-components/vs-visit/vs-visit.component';
import {
    VsDocumentVisitActionComponent
} from './component/vs-document-visit-action/vs-document-visit-action.component';

/**
 * Angular module for the Visit (vs) feature.
 *
 * AP-2.7 scope: Visit CRUD via the house metadata-driven pattern.
 *  - {@link VsVisitComponent}: ObjectBaseComponent rendering the Visit detail and
 *    the related Besuchsprotokoll sub-widget (dialog + object page rendering).
 *  - {@link VsVisitPage}: routable object page for a single visit.
 *  - {@link VsConfigPage}: config page listing Besuchstypen (vs.VisitType).
 *  - {@link VsDocumentVisitActionComponent}: "Besuch dokumentieren" action button
 *    that opens the vs.Visit create dialog (exported for cross-module use, e.g.
 *    the customer page or the conversation context panel).
 *
 * The module mirrors the {@code pc} (Phone Call) module pattern as directed
 * by the Phase 2 requirement. It is registered in {@code FeatureCrmModule}
 * and self-registers with the {@code ModuleRegistryService}.
 *
 * @ticket TM-1000001921
 */
@NgModule({
    declarations: [
        VsConfigPage,
        VsVisitPage,
        VsVisitComponent,
        VsDocumentVisitActionComponent,
    ],
    exports: [
        VsVisitComponent,
        VsDocumentVisitActionComponent,
    ],
    imports: [
        CoreModule,
    ],
    providers: [VS_ENTITY_PROVIDER]
})
export class VsModule implements DynamicModule {

    alias = 'vs';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    // vs has no dedicated KPI/statistics components in Phase 2 (data layer only).
    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }

}
